import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


Vue.config.productionTip = false

//Global css
require('./assets/style.scss');

// Mask
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;

  // Proteção de rotas administrativas
  if (to.path.startsWith('/admin') && to.name !== 'AdminLogin') {
    const token = localStorage.getItem('admin_token');
    if (!token) {
      return next({ name: 'AdminLogin' });
    }
  }

  next();
})

// Import axios
import axios from 'axios'
import VueAxios from 'vue-axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

// Definir a chave da API no cabeçalho de todas as requisições
axios.defaults.headers.common['x-api-key'] = process.env.VUE_APP_API_KEY;

// Interceptor para adicionar o token JWT em requisições administrativas
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});


 
Vue.use(VueAxios, axios)

new Vue({
  router,
  store,
  // mixins: [mixins],
  render: function (h) { return h(App) }
}).$mount('#app')
